import {
    ORGANIZATION_HOST,
    ORGANIZATION_INSTANCE,
    ACCOUNT_HOST,
    ACCOUNTS_INSTANCE,
    SURVEY_HOST,
    SURVEY_INSTANCE,
} from "@/helper/consts";
import {checkUrlAllowedWithParameters, getUrlAllowed, getUrlWithParameters, makeMediaHostUrl} from "@/helper/urls";


export default {
    getAccountsUrlWithParameters:
      /**
       * Создает URL для аутентификации с параметрами
       * @param {string} name - Имя конечной точки API
       * @param {string} method - HTTP метод
       * @param {Object} parameters - Параметры пути URL
       * @param {Object} gets - Query-параметры
       * @returns {string} Сформированный URL для API аккаунтов
       */
      function (name, method, parameters, gets) {
        return getUrlWithParameters(
            ACCOUNT_HOST, ACCOUNTS_INSTANCE, name, method, parameters, gets
        );
    },
    getSurveyUrlWithParameters:
      /**
       * Создает URL для API опросов с параметрами
       * @param {string} name - Имя конечной точки API
       * @param {string} method - HTTP метод
       * @param {Object} parameters - Параметры пути URL
       * @param {Object} gets - Query-параметры
       * @returns {string} Сформированный URL для API опросов
       */
      function (name, method, parameters, gets) {
        return getUrlWithParameters(
            SURVEY_HOST, SURVEY_INSTANCE, name, method, parameters, gets
        );
    },
    getWorkerUrlWithParameters:
      /**
       * Создает URL для работников с параметрами
       * @param {string} name - Имя конечной точки API
       * @param {string} method - HTTP метод
       * @param {Object} parameters - Параметры пути URL
       * @param {Object} gets - Query-параметры
       * @returns {string} Сформированный URL для API организаций
       */
      function (name, method, parameters, gets) {
        return getUrlWithParameters(
            ORGANIZATION_HOST, ORGANIZATION_INSTANCE, name, method, parameters, gets
        );
    },
    allowedPayUrl(name, method) {
      /**
       * Проверяет разрешение доступа к URL для платежных операций
       * @param {string} name - Имя конечной точки API
       * @param {string} method - HTTP метод
       * @returns {string} URL для проверки разрешений платежных операций
       */
        return getUrlAllowed(SURVEY_HOST, name, method)
    },
    allowedPayUrlByParameters(name, method, parameters) {
      /**
       * Проверяет разрешение доступа к URL для платежных операций с параметрами
       * @param {string} name - Имя конечной точки API
       * @param {string} method - HTTP метод
       * @param {Object} parameters - Параметры пути URL
       * @returns {string} URL для проверки разрешений платежных операций с параметрами
       */
        return checkUrlAllowedWithParameters(SURVEY_HOST, SURVEY_INSTANCE, name, method, parameters)
    },
    makeMessagingMediaUrl: function (append) {
      /**
       * Создает URL для медиа-файлов системы обмена сообщениями
       * @param {string} append - Дополнительный путь для медиа-файла
       * @returns {string} Полный URL для медиа-файла
       */
        return makeMediaHostUrl(SURVEY_HOST, append)
    },
}
